import { AccordionSummary, Button, Grid, Input, NativeSelect, Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Paper from '@material-ui/core/Paper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loading from '../../../../components/Loading';
import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import { handleErrorRequest } from '../../../../utils/errorsValidation';
import { formatDateTimeToRender } from '../../../../utils/functions';
import useStyles from '../style';

export function AnchorProviderRegister() {
  const classes = useStyles();
  const { id, idAncora } = useParams();

  const [isLoading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [anchors, setAnchors] = useState();
  const [provider, setProvider] = useState([]);

  const [getErros, setErros] = useState([]);

  const [formValues, setFormValues] = useState({
    status: 'Ativo',
  });

  const handleInputChange = (event, value) => {
    event.persist();
    setFormValues((inputs) => ({ ...inputs, [event.target.name]: value || event.target.value }));
  };

  const updateAnchor = async (payload) => {
    const payloadUpadte = {
      ...payload,
      fornecedorAncoraId: Number(idAncora),
      dataAtualizacao: formValues.dataAtualizacao,
    };
    try {
      const response = await api.put('FornecedoresAncoras', payloadUpadte);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Rede do fornecedor alterada com sucesso!');
        setFormValues(response.data.resposta);
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const createAnchor = async (payload) => {
    try {
      const response = await api.post('FornecedoresAncoras', payload);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Rede do fornecedor criada com sucesso!');
        setFormValues({
          status: 'Ativo',
          ancoraId: 0,
          codigoInterno: '',
          fornecedorId: 0,
          nomeInterno: '',
        });
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      setErros(handleErrorRequest(error.response));
    }
  };

  const onSubmit = async () => {
    const payload = {
      ...formValues,
      ...(formValues.ancoraId && { ancoraId: Number(formValues.ancoraId) }),
      ...(id && { fornecedorId: Number(id) }),
      dataUltimaProposta: isRegister ? null : formValues.dataUltimaProposta,
      dataUltimaAprovacao: isRegister ? null : formValues.dataUltimaAprovacao,
    };
    isRegister ? createAnchor(payload) : updateAnchor(payload);
  };

  const fetchProviderById = async (anchorId) => {
    if (!anchorId) return;
    setLoading(true);
    try {
      const res = await api.get(`FornecedoresAncoras/ConsultarId?id=${anchorId}`);
      setFormValues(res.data.resposta);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const fetchAnchors = async () => {
    const res = await api.get('Ancoras/Consultar?status=Ativo');
    setAnchors(res.data.resposta);
  };

  const fetchProvider = async () => {
    const res = await api.get(`Fornecedores/ConsultarId?id=${id}`);
    setProvider(res.data.resposta);
  };

  useEffect(() => {
    fetchAnchors();
    fetchProvider();
    if (window.location.pathname.includes('cadastrar')) {
      setLoading(false);
      setIsEditing(true);
      setIsRegister(true);
      return;
    }
    if (window.location.pathname.includes('editar')) {
      setIsEditing(true);
      fetchProviderById(idAncora);
      return;
    }
    fetchProviderById(idAncora);
    setIsEditing(false);
    setIsRegister(false);
  }, [idAncora]);

  return (
    <div className={classes.root}>
      <Header />
      {isEditing ? (
        <Subheader
          title={`${isRegister ? 'Cadastrando' : 'Atualizando'} rede do fornecedor - ${
            provider?.nomeFantasia
          }`}
          loading={isLoading}
          submit={onSubmit}
          back={false}
          submitText={`${isRegister ? 'Cadastrar' : 'Atualizar'}`}
        />
      ) : (
        <Subheader
          loading={isLoading}
          back={false}
          title={`Visualizando rede do fornecedor - ${provider?.nomeFantasia ?? ''}`}
        />
      )}
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <form onSubmit={onSubmit}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Informações</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Rede</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            onChange={handleInputChange}
                            className={classes.input}
                            value={formValues?.ancoraId}
                            name="ancoraId"
                            disabled={!isEditing && !isRegister}
                            error={getErros.includes('Ancora')}
                            onBlur={(event) =>
                              getErros.includes('Ancora') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Ancora';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {anchors?.map((anchor) => (
                              <option key={anchor.ancoraId} value={anchor.ancoraId}>
                                {anchor.nomeFantasia}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Status</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            disabled={!isEditing}
                            className={classes.input}
                            value={formValues?.status}
                            name="status"
                            onChange={handleInputChange}
                            error={getErros.includes('Status')}
                            onBlur={(event) =>
                              getErros.includes('Status') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Status';
                                }),
                              )
                            }
                          >
                            <option value="Ativo">Ativo</option>
                            <option value="Inativo">Inativo</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Nome Interno</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Nome Interno"
                            onChange={handleInputChange}
                            value={formValues?.nomeInterno || ''}
                            disabled={!isEditing}
                            name="nomeInterno"
                            error={getErros.includes('NomeInterno')}
                            onBlur={(event) =>
                              getErros.includes('NomeInterno') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'NomeInterno';
                                }),
                              )
                            }
                            inputProps={{
                              minLength: 3,
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Código interno</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Código Interno"
                            onChange={handleInputChange}
                            value={formValues?.codigoInterno || ''}
                            disabled={!isEditing}
                            name="codigoInterno"
                            error={getErros.includes('CodigoInterno')}
                            onBlur={(event) =>
                              getErros.includes('CodigoInterno') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'CodigoInterno';
                                }),
                              )
                            }
                            inputProps={{
                              minLength: 0,
                              maxLength: 20,
                            }}
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Ignorar Metas</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={formValues?.ignorarMetas}
                            disabled={!isEditing}
                            name="ignorarMetas"
                            onChange={handleInputChange}
                            error={getErros.includes('IgnorarMetas')}
                            onBlur={(event) =>
                              getErros.includes('IgnorarMetas') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'IgnorarMetas';
                                }),
                              )
                            }
                          >
                            <option value="NaoIgnorar">Não Ignorar</option>
                            <option value="Ignorar">Ignorar</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {!isRegister && (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className={classes.summary}
                    >
                      <Typography className={classes.heading}>Dados do Registro</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>Data de Registro</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataRegistro &&
                                formatDateTimeToRender(formValues.dataRegistro)
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data do Registro"
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Atualização</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataAtualizacao
                                  ? formatDateTimeToRender(formValues.dataAtualizacao)
                                  : ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Atualização"
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {!isRegister && (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                      className={classes.summary}
                    >
                      <Typography className={classes.heading}>Dados das Propostas</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Ultima Proposta</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataUltimaProposta ?
                                formatDateTimeToRender(formValues.dataUltimaProposta) :
                                ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Ultima Proposta"
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Ultima Aprovação</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataUltimaAprovacao
                                  ? formatDateTimeToRender(formValues.dataUltimaAprovacao)
                                  : ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Ultima Aprovação"
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {(isRegister || isEditing) && (
                  <div className={classes.divButton}>
                    <button
                      variant="contained"
                      type="button"
                      onClick={onSubmit}
                      className={classes.button}
                    >
                      {isRegister ? 'Cadastrar' : 'Atualizar'}
                    </button>
                  </div>
                )}
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
